export default {
  default: () => import("C:/Users/Nikola_Johnny_33/Desktop/Projects/my-portfolio/layouts/default.vue").then(m => m.default || m)
}